import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});

api.interceptors.request.use(
  (config) => {
    const loggedUser = JSON.parse(localStorage.getItem("asu"));
    if (loggedUser && loggedUser.token) {
      const token = `Bearer ${loggedUser.token}`;
      // Envia ambos os cabeçalhos para máxima compatibilidade
      config.headers["Auth"] = token;
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { api };

export const createSession = async (username, password) => {
  return api.post("login.php", { withCredentials: false, username, password });
};

export const getPoints = async () => {
  return api.get("points.php");
};

export const getAlarms = async () => {
  try {
    const response = await api.get("alarms.php");
    return response;
  } catch (error) {
    console.error("Erro ao buscar alarmes:", error);
    return { data: [] };
  }
};

export const getDetails = async (id, pointType, dateTime) => {
  return api.get("details.php", { params: { id, pointType, dateTime } });
};

export const update = async (id, data) => {
  return api.patch("update.php", { id, ...data });
};

export const updateConfig = async (id, receiveNotifications, timeInterval) => {
  const origin = navigator.userAgent;
  return api.patch("update-config.php", {
    withCredentials: true,
    id,
    receiveNotifications,
    timeInterval,
    origin,
  });
};

export const storeFCMToken = (userId, token) => {
  const origin = navigator.userAgent;
  return api.post("fcm-subscription.php", {
    withCredentials: true,
    userId,
    token,
    origin,
  });
};
